/*===================================
||
|| DevicesContext
||
===================================*/
import React, { createContext, useMemo, useState } from "react";
import PropTypes from "prop-types";

/*---------------------------
| Context
---------------------------*/
export const DevicesContext = createContext();
DevicesContext.displayName = "Devices Context";

// components
import MountingWrapper from "./MountingWrapper";

// Provider
export const DevicesProvider = ({ children }) => {
    const [isIOS, setIsIOS] = useState();
    const value = useMemo(() => ({ isIOS, setIsIOS }), [isIOS, setIsIOS]);
    return (
        <DevicesContext.Provider value={value}>
            <MountingWrapper>{children}</MountingWrapper>
        </DevicesContext.Provider>
    );
};

// prop-types
DevicesProvider.propTypes = {
    children: PropTypes.any
};
